let timezoneFactory = function () {
    let getTimezoneList = () => {
        return [
            {
                label: 'Browser Timezone',
                value: moment.tz.guess()
            },
            {
                label: 'AKST9AKDT',
                value: 'US/Alaska'
            },
            {
                label: 'AST4ADT',
                value: 'Canada/Atlantic'
            },
            {
                label: 'CST6CDT',
                value: 'CST6CDT'
            },
            {
                label: 'EST5EDT',
                value: 'EST5EDT'
            },
            {
                label: 'HST10HDT',
                value: 'US/Hawaii'
            },
            {
                label: 'MST7MDT',
                value: 'MST7MDT'
            },
            {
                label: 'PST8PDT',
                value: 'PST8PDT'
            },
            {
                label: 'AKST',
                value: 'Etc/GMT+9'
            },
            {
                label: 'AST',
                value: 'Etc/GMT+4'
            },
            {
                label: 'CST',
                value: 'Etc/GMT+6'
            },
            {
                label: 'EST',
                value: 'Etc/GMT+5'
            },
            {
                label: 'HST',
                value: 'Etc/GMT+10'
            },
            {
                label: 'MST',
                value: 'Etc/GMT+7'
            },
            {
                label: 'PST',
                value: 'Etc/GMT+8'
            },
        ]
    }

    return {
        getTimezoneList
    }
}

timezoneFactory.$inject = [];

export default timezoneFactory;


// WEBPACK FOOTER //
// ./client/app/common/timezone-list/timezone-list.factory.js